import React, { useContext, useMemo } from "react";
import { Intro } from "components/commons";
import locale from "localization";
import ShiftRecordsFilter from "./shift-records-filter";
import { shiftRecordColumns } from "./shift-records-column";
import { initialShiftRecordFilterState } from "./shift-records-filter.state";
import { mapFilterToRequest, mapDataToList } from "./shift-records.mapper";
import useDataTable from "hooks/useDataTable";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { useRouter } from "hooks";
import { getShifts } from "apis";
import { ShiftStatus, Portal } from "enums";
import { UserContext } from "contexts";

const ShiftRecordsModule = () => {
  const { history } = useRouter();
  const { user } = useContext(UserContext);

  const stationCodes = useMemo(() => {
    const codes = user?.userAccesses
      ?.filter((access) => access.portal === Portal.HOS && access.station?.stationCode)
      .map(({ station }) => station.stationCode);
    return codes?.length > 0 ? codes.join(",") : undefined;
  }, [user?.userAccesses]);

  const { filter, search, table } = useDataTable({
    api: {
      api: getShifts,
      params: {
        page: 1,
        perPage: 10,
        statuses: ShiftStatus.Closed,
        stationCodes,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: { initialState: initialShiftRecordFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "shifts",
      mapper: (shifts) =>
        mapDataToList({
          shifts,
          history,
        }),
      columns: shiftRecordColumns,
    },
  });

  return (
    <>
      <Intro title={locale.shirtReport} />
      <ShiftRecordsFilter {...filter} {...search} />
      <DataTableV2 {...table} />
    </>
  );
};

export default ShiftRecordsModule;
